export function _(key) {
  return key;
}

export function currencyFormat(value) {
  if (value) {
    return value.toFixed(2).replace(".", ",");
  }
  return value;
}

export function kiloFormat(value) {
  return value.toFixed(2);
}

export function milliFormat(value) {
  return value.toFixed(0);
}

export function weight_conversion(weight_in_cart, base_unit) {
  const weight = { milli: "g", kilo: "kg" };
  const volume = { milli: "ml", kilo: "l" };
  const unit_names = base_unit.measure == "weight" ? weight : volume;
  const { milli, kilo } = unit_names;

  if (weight_in_cart >= 1000) {
    return kiloFormat(weight_in_cart * 0.001) + kilo;
  }
  return milliFormat(weight_in_cart) + milli;
}
